export default __webpack_public_path__ + "static/media/circle-dot.062f3bf5.svg";